import type { FC } from 'react';
import css from './appControl.module.scss';
import { supportLinkLocales } from './const';
import EFVideo from '@/components/UI/EFVideo';
import EFAppArrow from '@/components/UI/svg/Icons/EFAppArrow';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';

const AppControl: FC = () => {
    const { useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();
    const imageLocal = getImageLocal(locale, ['cn', 'es']);

    return (
        <div className={css.appControl}>
            <div className="text-box">
                <div className="f-tip">{t('delta2.aniK_msg1')}</div>
                <div className="f-title" style={locale === 'fr' ? { fontSize: '0.29rem' } : {}}>
                    {t('delta2.aniK_msg2')}
                </div>
                <div className="f-des">{t('delta2.aniK_msg3')}</div>
            </div>
            <div className="controls-box">
                <EFVideo className="video" sources={[`/video/delta2-h5/app_${imageLocal}.webm`, `/video/delta2-h5/app_${imageLocal}.mp4`]} />
                <div className="f-text">
                    <div className="f-title" style={locale === 'fr' ? { fontSize: '0.2rem' } : {}}>
                        {t('delta2.aniK_msg4')}
                    </div>
                    <div className="f-des">{t('delta2.aniK_msg5')}</div>
                    {supportLinkLocales.includes(locale) && (
                        <Link href="/app" className="link_learn" newWin>
                            <div className="text2">{t('delta2.learn_more')}</div>
                            <div className="icon">
                                <EFAppArrow />
                            </div>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AppControl;
